/**
 * 本文件处理后端回调相关路由链接
 */

/**
 * 前端定义的回调相关链接
 */
export enum CallbackUrl {
    /**
     * 重新授权店铺链接
     */
    REAUTH_SHOP = "/callback/reauthShop",
    /**
     * 拼多多地址解密验证回调
     */
    PDD_VERIFY_AUTH = "/callback/pddVerifyAuth",

    /**
     * 预付款相关支付结果页面回调
     */
    PAYMENT_RESULT = "/callback/paymentResult",
}

/**
 * 回调callback地址key
 */
const ROUTER_CACHE_KEY = "_ROUTER_CACHE_KEY";

/**
 * 通过缓存获取回调链接
 */
export function getCacheCallbackUrl() {
    const cachePath = localStorage.getItem(ROUTER_CACHE_KEY);
    localStorage.removeItem(ROUTER_CACHE_KEY);

    return cachePath;
}

/**
 * 缓存回调链接
 */
export function saveCacheCallbackUrl(callbackUrl: CallbackUrl) {
    localStorage.setItem(ROUTER_CACHE_KEY, callbackUrl);
}
